@if(showWarning() && validationResult()) {
<!-- Display shipping warning with details -->
<div class="shipping-warning alert" 
    [class.alert-danger]="getWarningType() === 'danger'"
    [class.alert-warning]="getWarningType() === 'warning'"
    [class.alert-info]="getWarningType() === 'info'"
>

    <div class="d-flex align-items-start">
        <i [class]="getWarningIcon()" class="me-3 mt-1"></i>

        <div class="flex-grow-1">
            <h6 class="alert-heading mb-2">
                @if (!validationResult()!.isShippingAvailable) {
                    <span>{{ 'IDS_SHIPPING_NOT_AVAILABLE' | translate }}</span>
                }
                @if (validationResult()!.isShippingAvailable && validationResult()!.unavailableCountries.length > 0) {
                    <span>{{ 'IDS_SHIPPING_PARTIALLY_AVAILABLE' | translate }}</span>
                }
            </h6>

            <p class="mb-2">{{ validationResult()!.message }}</p>

            <!-- Show unavailable countries if any -->
            @if(validationResult()?.unavailableCountries?.length > 0) {
            <div class="mb-2 countries-expandable">
                <small class="text-muted">
                    {{ 'IDS_SHIPPING_NOT_AVAILABLE_TO' | translate }}:
                    <strong class="country-list">{{ unavailableCountriesDisplay().join(', ') }}</strong>
                    
                    @if (showExpandUnavailableCountries() && !isUnavailableCountriesExpanded()) {
                    <span class="more-indicator">
                        , ...
                        <button type="button" class="expand-toggle" (click)="toggleUnavailableCountriesExpansion()"
                            [attr.aria-label]="'IDS_SHOW_MORE_COUNTRIES' | translate">
                            {{ 'IDS_SHOW_MORE' | translate }}
                            (+{{ unavailableCountriesRemainingCount() }})
                        </button>
                    </span>
                    }
                    
                    @if (showExpandUnavailableCountries() && isUnavailableCountriesExpanded()) {
                    <button type="button" class="expand-toggle" (click)="toggleUnavailableCountriesExpansion()"
                        [attr.aria-label]="'IDS_SHOW_LESS_COUNTRIES' | translate">
                        {{ 'IDS_SHOW_LESS' | translate }}
                    </button>
                    }
                </small>
            </div>
            }
            <!-- Show available countries if shipping rate is configured -->
            @if (validationResult()!.availableCountries.length > 0) {
                <div class="mb-2 countries-expandable">
                    <small class="text-muted">
                        {{ 'IDS_SHIPPING_AVAILABLE_TO' | translate }}:
                        <span class="country-list">{{ availableCountriesDisplay().join(', ') }}</span>
                        
                        @if (showExpandAvailableCountries() && !isAvailableCountriesExpanded()) {
                        <span class="more-indicator">
                            , ...
                            <button type="button" class="expand-toggle" (click)="toggleAvailableCountriesExpansion()"
                                [attr.aria-label]="'IDS_SHOW_MORE_COUNTRIES' | translate">
                                {{ 'IDS_SHOW_MORE' | translate }}
                                (+{{ availableCountriesRemainingCount() }})
                            </button>
                        </span>
                        }
                        
                        @if (showExpandAvailableCountries() && isAvailableCountriesExpanded()) {
                        <button type="button" class="expand-toggle" (click)="toggleAvailableCountriesExpansion()"
                            [attr.aria-label]="'IDS_SHOW_LESS_COUNTRIES' | translate">
                            {{ 'IDS_SHOW_LESS' | translate }}
                        </button>
                        }
                    </small>
                </div>
            }

            <!-- Actions -->
            <div class="mt-3">
                <a type="link" class="btn btn-gold btn-sm me-2" routerLink="/{{
                    this.languageService.userSelectedLanguage.code
                }}/account/shipping-addresses">
                    <i class="fas fa-plus me-1"></i>
                    {{ 'IDS_MANAGE_SHIPPING_ADDRESSES' | translate }}
                </a>

            </div>
        </div>
    </div>
</div>
}
